import React, { useState, useEffect, useCallback } from "react";
import "./listaAgendados.css";
import { getAgendamentos } from "../../../../API/ListaAgendamentos";

function ListaAgendados({ refreshFlag }) {
  const [listaAgendados, setListaAgendados] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getAgendamentos();
      const dataComExecucao = calcularTempoRestante(data);
      setListaAgendados(dataComExecucao);
    };
    fetchData();
  }, [refreshFlag]);

  const recarregar = useCallback(async () => {
    const data = await getAgendamentos();
    const dataComExecucao = calcularTempoRestante(data);
    setListaAgendados(dataComExecucao);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      recarregar();
    }, 60000);

    return () => clearInterval(intervalId); // Limpa o intervalo quando o componente é desmontado
  }, [recarregar]);

  const calcularTempoRestante = (agendamentos) => {
    return agendamentos.map((item) => {
      const agora = new Date();
      const partesHoraFim = item.fim.split(":");
      const partesHoraInicio = item.inicio.split(":");

      const horaFim = new Date(
        agora.getFullYear(),
        agora.getMonth(),
        agora.getDate(),
        parseInt(partesHoraFim[0]),
        parseInt(partesHoraFim[1])
      );

      const horaInicio = new Date(
        agora.getFullYear(),
        agora.getMonth(),
        agora.getDate(),
        parseInt(partesHoraInicio[0]),
        parseInt(partesHoraInicio[1])
      );

      if (agora >= horaInicio && agora <= horaFim) {
        item.execucao = "Executando...";
      } else {
        let diferencaMs;
        if (agora < horaInicio) {
          diferencaMs = horaInicio - agora;
        } else {
          // Adicionar um dia à data de início se a hora atual for maior que a hora de fim
          horaInicio.setDate(horaInicio.getDate() + 1);
          diferencaMs = horaInicio - agora;
        }

        const diferencaHoras = Math.floor(diferencaMs / 3600000);
        const diferencaMinutos = Math.floor((diferencaMs % 3600000) / 60000);
        item.execucao = `${diferencaHoras}:${diferencaMinutos < 10 ? '0' : ''}${diferencaMinutos+1}`;
      }

      return item;
    });
  };

  const handleDelete = async (nome, inicio) => {
    const confirmDelete = window.confirm(`Deseja realmente excluir o agendamento ${nome}?`);
    if (confirmDelete) {
      try {
        const response = await fetch('https://terradirimini.convergedigital.com.br/excluirAgendamento', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ nome, inicio }),
        });

        if (response.ok) {
          alert('Agendamento excluído com sucesso!');
          recarregar();
        } else {
          alert('Erro ao excluir o agendamento.');
        }
      } catch (error) {
        console.error('Erro ao excluir o agendamento:', error);
        alert('Erro ao excluir o agendamento.');
      }
    }
  };

  return (
    <div id="agendamentos-listAgendamentos-mobile">
      <div id="content-lista-listAgendamentos-mobile">
        <h1 className="textPrincipal-listAgendamentos-mobile">
          Lista de Agendamentos
        </h1>
        <div id="div-table-listAgendamentos-mobile">
          <table id="tabela-listAgendamentos-mobile">
            <thead>
              <tr>
                <th>Grupo</th>
                <th>Inicio</th>
                <th>Fim</th>
                <th>Tipo</th>
                <th>Execução</th>
              </tr>
            </thead>
            <tbody id="tabelaAgendamentos-listAgendamentos-mobile">
              {listaAgendados.length === 0 ? (
                <tr>
                  <td colSpan="5">Nenhum agendamento registrado.</td>
                </tr>
              ) : (
                listaAgendados.map((item, index) => (
                  <tr key={index}>
                    <td className="tdNome-listAgendamentos-mobile" onClick={() => handleDelete(item.nome, item.inicio)}>
                      {item.nome}
                    </td>
                    <td>{item.inicio}</td>
                    <td>{item.fim}</td>
                    <td>{item.tipo}</td>
                    <td style={{backgroundColor: item.execucao === "Executando..." ? "#3dbd12" : "transparent", color: item.execucao === "Executando..." ? "white" : "black" }}>
                      {item.execucao}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ListaAgendados;